import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatRippleModule } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule, Routes } from '@angular/router';
import { FcConfirmCloseDialogModule } from '@core/components/fc-confirm-close-dialog/fc-confirm-close-dialog.module';
import { AuthenticatedGuard } from '@core/guard/authenticated.guard';
import { FuseSidebarModule } from '@fuse/components';
import { FuseSharedModule } from '@fuse/shared.module';
import { TranslateModule } from '@ngx-translate/core';
import { DialogSegmentsModule } from './dialogs/dialog-segments.module';
import { SegmentsFiltersModule } from './filters/filters.module';
import { SegmentComponent } from './segments.component';
import { SegmentService } from './services/segment.service';

const routes: Routes = [
  {
    path: 'segmentos',
    component: SegmentComponent,
    canActivate: [AuthenticatedGuard],
    data: { title: 'CORE.SERVICES.NAVIGATION.SEGMENTS' }
  }
];

@NgModule({
  declarations: [
    SegmentComponent
  ],
  imports: [
    RouterModule.forChild(routes),
    TranslateModule,
    MatProgressSpinnerModule,
    MatIconModule,
    MatTooltipModule,
    MatSortModule,
    MatPaginatorModule,
    MatTableModule,
    MatButtonModule,
    MatRippleModule,
    MatSortModule,
    MatMenuModule,
    FuseSharedModule,
    FuseSidebarModule,
    SegmentsFiltersModule,
    DialogSegmentsModule,

    FcConfirmCloseDialogModule
  ],
  exports: [
    SegmentComponent
  ],
  providers: [
    SegmentService
  ]
})

export class SegmentsModule { }
